/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Target_JoorInputs */

const en_sync_target_joor = /** @type {(inputs: Sync_Target_JoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joor`)
};

/**
* | output |
* | --- |
* | "Joor" |
*
* @param {Sync_Target_JoorInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const sync_target_joor = /** @type {((inputs?: Sync_Target_JoorInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Target_JoorInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_sync_target_joor(inputs)
});